import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { withUIETheme } from '../uietheme/withUIETheme';
const MenuHeading = ({ children, uieTheme }) => {
    const baseStyle = {
        textTransform: 'uppercase',
        margin: 0,
        paddingBottom: '0.4rem',
        marginBottom: uieTheme.spacing.space0,
        color: uieTheme.colors.textMenuHeading,
        fontSize: uieTheme.fontSizes.small,
    };
    return (React.createElement(FelaComponent, { style: [baseStyle, uieTheme.fontStyles.headline], as: "h3" }, children));
};
export default withUIETheme(MenuHeading);
//# sourceMappingURL=MenuHeading.js.map